import { useI18n } from "../../utils/translate/i18n/useI18n";
import TonalResultChart from "../../pages/tonal-audiometry/components/tonalChartResult";
import type { TonalResultPanelModel } from "../../type/result";

export default function TonalResultComponent({
  result,
  className,
  bodyClassName = "card-body p-4",
  header,
  children
}: TonalResultPanelModel) {
  const { t } = useI18n();
  const panelClassName = ["panel", "card", "border-0", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={panelClassName}>
      <div className={bodyClassName}>
        {header}

        {children}

        {result && (
          <>
            <TonalResultChart data={result.left} label={t("Ucho lewe")} ear="left" />
            <TonalResultChart data={result.right} label={t("Ucho prawe")} ear="right" />
          </>
        )}

        {/* ── Disclaimer ──────────────────────────────────────────────────── */}
        <div className="test-panel__notice mt-3" role="note">
          <div className="test-panel__notice-title">
            <i className="bi bi-info-circle-fill" aria-hidden="true" />
            <span> {t("PAMIĘTAJ !")}</span>
          </div>
          <p className="test-panel__notice-text mb-0" style={{ color: "#374151" }}>
            {t("Badanie ma charakter wyłącznie informacyjny. Nie stanowi podstawy do diagnozy ani leczenia medycznego. W celu potwierdzenia wyników zalecamy umówienie się na profesjonalne badanie słuchu w naszym gabinecie, które jest wykonywane na certyfikowanym sprzęcie medycznym, co zapewnia wysoką precyzję i wiarygodność wyników.")}
          </p>
        </div>
      </div>
    </div>
  );
}